import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getFirebase } from "../firebase/init.js";
import { useAuthStore } from "../stores/auth.js";
import { useTableStore } from "../stores/table.js";

interface TableSummary {
  id: string;
  meta?: {
    name?: string;
    gmUid?: string;
  };
}

export default function Lobby() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const uid = useAuthStore((s) => s.uid);
  const setTable = useTableStore((s) => s.setTable);
  const [tables, setTables] = useState<TableSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!uid) return undefined;
    const { db } = getFirebase();
    const q = query(collection(db, "tables"), where("meta.memberUids", "array-contains", uid));
    const unsub = onSnapshot(
      q,
      (snap) => {
        setTables(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<TableSummary, "id">) })));
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
    );
    return () => unsub();
  }, [uid]);

  useEffect(() => {
    if (loading || tables.length === 0) return;
    const match = tables[0];
    if (match?.meta?.name && match.meta.gmUid) {
      setTable(match.id, { name: match.meta.name, gmUid: match.meta.gmUid });
      navigate("/table", { replace: true });
    }
  }, [tables, loading, navigate, setTable]);

  const status = error ? `error: ${error.message}` : loading ? "loading" : "no-match";
  return (
    <p className="p-4">
      {loading ? t("app.loading") : t("lobby.no-table")}{" "}
      <span className="opacity-60">[{status}]</span>
    </p>
  );
}
